"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

// Returns true when an a file is an image file.
function isImage(file) {
  return file.type.split('/')[0] === 'image';
}

var _default = isImage;
exports["default"] = _default;